// src/App.tsx
// Updated: 2026-07-30 22:39:20 CDT
// Purpose: Admin application routing with authenticated route protection.

import React from "react";
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import {
  Helmet,
  HelmetProvider,
} from "react-helmet-async";

import ProtectedRoute from "@/auth/ProtectedRoute";
import AdminPage from "@/pages/admin";
import Login from "@/pages/Login";
import AudioRecoveryWindow from "@/pages/admin/AudioRecoveryWindow";
import GoogleErrorReports from "@/pages/admin/GoogleErrorReports";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>TableRead.tv — Admin</title>
        <meta
          name="robots"
          content="noindex, nofollow"
        />
      </Helmet>

      <Routes>
        <Route
          path="/login"
          element={<Login />}
        />

        <Route element={<ProtectedRoute />}>
          <Route path="/admin/recovery" element={<AudioRecoveryWindow />} />
          <Route path="/admin/google-diagnostics" element={<GoogleErrorReports />} />
          <Route
            path="/"
            element={
              <Navigate
                to="/admin"
                replace
              />
            }
          />

          <Route
            path="/admin"
            element={<AdminPage />}
          />

          <Route
            path="*"
            element={
              <Navigate
                to="/admin"
                replace
              />
            }
          />
        </Route>
      </Routes>
    </HelmetProvider>
  );
};

export default App;
